/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};

// Get the variants product JSON from the page based on the product ID

const productContainer = document.querySelector('[data-product-id]');
const productId = productContainer ? productContainer.getAttribute('data-product-id') : null;

if (!productId) {
    console.error('No product ID found');
    return;
}
  
const productJsonId = 'product-variants-json-' + productId;
const productJson = document.getElementById(productJsonId);

if (!productJson) {
    console.error('Product JSON not found for product ID:', productId);
    return;
}

const productVariantData = JSON.parse(productJson.innerText);
const variants = productVariantData.product.variants;

// Product constructor
class ProductSwatch extends HTMLElement {
  constructor() {
    super();

    this.onColorSwatchClickBound = this.onColorSwatchClick.bind(this);
    this.onVariantChangedBound = this.onVariantChanged.bind(this);
    this.updatePriceButtonBound = this.updatePriceButton.bind(this);
    
    // Store selected price and currency temporarily
    this.selectedPrice = null;
    this.selectedCurrencySymbol = '';
  }

  connectedCallback() {
    // Select color swatches
    this.colorSwatches = this.querySelectorAll('.swatch-element.color');
    this.setEventListeners();

    // Listen for quantity change
    this.listenToQuantityChange();
  }

  setEventListeners() {
    // Add event listeners to color swatches
    this.colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', this.onColorSwatchClickBound);
    });

    // Listen for variant change event
    const productForm = this.closest('.product-single-wrapper') || this.closest('#product-box');
    if (productForm) productForm.addEventListener('variant:changed', this.onVariantChangedBound);

    // Store the initial price and currency when page loads
    this.storeInitialPrice();
    // Store product conditionnement
    this.storeProductConditionnement();
  }

  listenToQuantityChange() {
    const quantityInput = document.querySelector('#Quantity'); // The input where quantity is displayed
    const minusButton = document.querySelector('.js-qty__adjust--minus'); // The minus button
    const plusButton = document.querySelector('.js-qty__adjust--plus'); // The plus button

    // Update price when quantity changes
    const updatePrice = () => {
      const priceElement = document.querySelector('#price_on_button');
      if (priceElement && this.selectedPrice) {
        let quantity = parseInt(quantityInput.value);
        if (isNaN(quantity) || quantity < 1) quantity = 1; // Ensure valid quantity

        const totalPrice = this.selectedPrice * quantity;
        const formattedPrice = (totalPrice / 100).toFixed(2).replace('.', ',');
        priceElement.textContent = `${formattedPrice} ${this.selectedCurrencySymbol}`;
      }
    };

    // Listen to quantity input changes
    quantityInput.addEventListener('input', updatePrice);

    // Listen for clicks on the plus and minus buttons
    minusButton.addEventListener('click', () => {
      let quantity = parseInt(quantityInput.value);
      if (quantity > 1) {
        quantityInput.value = quantity - 1;
        updatePrice();
      }
    });

    plusButton.addEventListener('click', () => {
      let quantity = parseInt(quantityInput.value);
      quantityInput.value = quantity + 1;
      updatePrice();
    });
  }

  storeInitialPrice() {
    // Store the initial price and currency symbol when page loads
    const priceOnButton = document.querySelector('#price_on_button');
    if (priceOnButton) {
      const priceText = priceOnButton.textContent.trim();
      const currencySymbol = this.getCurrencySymbol(priceOnButton);
      this.selectedPrice = parseFloat(priceText.replace(/[^0-9.,]/g, '').replace(',', '.')) * 100; // Convert price to integer (cent)
      this.selectedCurrencySymbol = currencySymbol;
    }
  }

  storeProductConditionnement() {
    // Store the initial conditionnement when page loads
    const conditionnementProduitNumber = document.querySelector('#conditionnement-produit-number');
    if (conditionnementProduitNumber) {
      const conditionnementText = conditionnementProduitNumber.textContent.trim();
      this.selectedConditionnement = conditionnementText;
    }
  }

  onVariantChanged(event) {
    const product = event.detail.product;
    const variant = event.detail.variant;

    console.log(variant.id);  
    
    // Ensure the variant exists
    if (!product || !variant) return;

    // Collect selected options based on variant data
    this.collectSelectedOptions(product, variant);

    // Store the selected price temporarily (for the new variant)
    this.selectedPrice = variant.price;
    this.selectedCurrencySymbol = this.getCurrencySymbol(document.querySelector('#price_on_button'));

    // Update the current variant ID in the data-current-variant attribute
    this.updateVariantId(variant.id);

    // After selecting new variant, update the price on the button
    this.updatePriceButton();

    // Now check if the variant exists in the variants array
    const matchingVariant = variants.find(v => v.id === variant.id);

    if (matchingVariant && matchingVariant.metafields && matchingVariant.metafields.custom) {
        const conditionnement = matchingVariant.metafields.custom.conditionnement;

        // Check if the #conditionnement-produit-number element exists
        const conditionnementElement = document.querySelector('#conditionnement-produit-number');
        if (conditionnementElement && conditionnement) {
            conditionnementElement.textContent = conditionnement;
        }

        // Now, calculate the price per unit if both the price and conditionnement exist
        const priceElement = document.querySelector('#conditionnement-produit-price');
        const priceByUnitElement = document.querySelector('#price_by_unit');

        if (priceElement && conditionnementElement && priceByUnitElement) {
            const price = parseFloat(priceElement.textContent.replace(/[^0-9.,]/g, '').replace(',', '.'));
            const conditionnementValue = parseFloat(conditionnement);

            if (price && conditionnementValue && conditionnementValue !== 0) {
                // Calculate price per unit and truncate to 2 decimal places
                let priceByUnit = price / conditionnementValue;

                // Truncate the number to 2 decimals (without rounding)
                priceByUnit = Math.floor(priceByUnit * 100) / 100;

                // Format to show decimal as a comma
                const formattedPriceByUnit = priceByUnit.toFixed(2).replace('.', ',');

                priceByUnitElement.textContent = `${formattedPriceByUnit} ${this.selectedCurrencySymbol}`;
            }
        }
    }
  }

  // Update the price on both the #price_on_button and #conditionnement-produit-price elements
  updatePriceButton() {
    const priceOnButton = document.querySelector('#price_on_button');
    const conditionnementPrice = document.querySelector('#conditionnement-produit-price');
    
    if (!priceOnButton || !conditionnementPrice) return;

    // Convert the selected price to money format (e.g., 12024 -> 120,24)
    const formattedPrice = (this.selectedPrice / 100).toFixed(2).replace('.', ',');

    // Update the price on #price_on_button
    priceOnButton.textContent = `${formattedPrice} ${this.selectedCurrencySymbol}`;

    // Update the price on #conditionnement-produit-price
    conditionnementPrice.textContent = `${formattedPrice} ${this.selectedCurrencySymbol}`;
  }

  // Extract the currency symbol from the data-currency attribute (or any other method)
  getCurrencySymbol(priceOnButton) {
    // Check if the priceOnButton element exists and has the data-currency attribute
    if (!priceOnButton || !priceOnButton.hasAttribute('data-currency')) {
      return ''; // Return empty string if currency symbol isn't found
    }

    // Get the currency data from the data-currency attribute
    return priceOnButton.getAttribute('data-currency') || '';
  }

  // Collect selected options (either from swatches or variant)
  collectSelectedOptions(product = null, variant = null) {
    const activeSwatches = this.querySelectorAll('.swatch-element.active');
    const selectedOptions = [];

    // Collect values from active swatches
    activeSwatches.forEach(swatch => {
      selectedOptions.push(swatch.getAttribute('data-value'));
    });

    if (product && variant) {
      product.options.forEach((option, index) => {
        selectedOptions[index] = variant[`option${index + 1}`];
      });
    }

    this.selectedOptions = selectedOptions;
  }

  // Handle click on color swatch
  onColorSwatchClick(event) {
    // Update active swatches
    this.updateActiveClass(event.currentTarget);

    // Collect selected options and update price
    this.collectSelectedOptions();
  }

  // Update active class on swatch
  updateActiveClass(swatch) {
    // Remove the active class from all swatches
    this.colorSwatches.forEach(swatch => {
      swatch.classList.remove('active');
    });

    // Add active class to clicked swatch
    swatch.classList.add('active');
  }

  // Update the data-current-variant attribute with the current variant ID 
  updateVariantId(variantId) {
    const productElement = this.closest('.product-single-wrapper') || this.closest('#product-box');
    if (productElement) {
      productElement.setAttribute('data-current-variant', variantId);
    }
  }

  // Remove event listeners when element is disconnected from the DOM
  disconnectedCallback() {
    // Remove event listeners from color swatches
    this.colorSwatches.forEach(swatch => {
      swatch.removeEventListener('click', this.onColorSwatchClickBound);
    });
  }
}

// Register the custom element if not already registered
if (!window.customElements.get('product-swatch')) {
  window.customElements.define('product-swatch', ProductSwatch);
}

/******/ })()
